module.exports = __webpack_public_path__ + "media/images/lb/512-ff193b401d387a15fae7b9fb8ba7f7e5.svg";